export default __webpack_public_path__ + "static/media/yd-s2.393ab247.png";